module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-43.f734d76c.jpg";